/* APPLICATION ROUTE CONSTANTS */
module.exports = Object.freeze({
  ROW_PER_PAGE: [10, 50, 100, 300, 500],

  // Status
  STATUS_REGISTER: "Register",

  /* Routers Link supplier_app */
  APP_HOME: "/applications",
  HOME: "/home",

  HOME_INTRO: "/hr-intro",
  DASHBOARD: "/hr-dashboard",
  INBOX: "/hr-inbox",
  OUTBOX: "/hr-outbox",

  HR_EMP_LIST:"/hr-emp-list",
  HR_EMP_CREATE:"/hr-emp-create",
  HR_EMP_DETAILS:"/hr-emp-details",
  ATD_CAL:"/attendance",

  HR_DOC_LIST:"/hr-doc-list",
  HR_DOC_CREATE:"/hr-doc-create",
  HR_DOC_DETAILS:"/hr-doc-details",
  HR_TASK_LIST:"/hr-task-list",
  HR_TASK_CAL:"/hr-task-cal",
  HR_TASK_DETAILS:"/hr-task-details",
  HR_ORG_STRUCTURE:"/hr-org",

  HR_ATD_LIST:"/hr-atd-list",
  HR_ATD_DETAILS:"/hr-atd-details",

  HR_EXPENSES_LIST:"/hr-expense-list",
  HR_EXPENSES_DETAILS:"/hr-expense-details",

  HR_CLIENT_LIST:"/hr-client-list",
  HR_CLIENT_DETAILS:"/hr-client-details",
  HR_CLIENT_CREATE:"/hr-client-create",

  HR_PROJECT_LIST:"/hr-project-list",
  HR_PROJECT_CREATE:"/hr-project-create",
  HR_PROJECT_DETAILS:"/hr-project-details",

  HR_RECEIPTS_LIST:"/hr-receipts-list",
  HR_RECEIPTS_DETAILS:"/hr-receipts-details",

});
